import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import { InfoText } from '@/modules/common/components/InfoText';

export const DefaultHeader = () => {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      sx={{ padding: '46px 16px 46px 16px', '&:hover': { cursor: 'default' } }}
    >
      <InfoText header={t('interface:properties.nothing_selected')} />
    </Stack>
  );
};
